import { useContext, useEffect, useState } from "react";
import { AuthContext, clienteAxios } from "../../../shared";
import { format } from "date-fns";
import { tipoConcesion } from "../../../shared/Helpers/CalculosConcesiones";
import { CalculoCuota, InsertCuotas, verificar_bug } from "../../../../functions/FunctionCuota";
import InfoPago from "../../../Gestion_pagos/Modals/InfoPago";
import Comprobante from "../../../Gestion_pagos/Modals/Comprobante";
import "../../../shared/styles/UnifiedTable.css";

const DetalleResumen = ({
    data, 
}) => {
    const authContext = useContext(AuthContext);
    const { usuario } = authContext;
    let deuda = 0.0;
    let resto = 0.0;
    let excedente_pago = null;
  
    const [detalles, setDetalles] = useState(null);
    const [concesion, setConcesion] = useState(null);
    const [concesion_baja, setConcesionBaja] = useState(null);
    const [comprobante, setComprobante] = useState(false);
  
  
    const fetchTrashPay = async (id) => {
      let pass = document.getElementById("confirm-password").value;
      let formData = new FormData();
      formData.append("id", id);
      formData.append("password", pass);
  
      const response = await clienteAxios({
        method: "post",
        url: "/Pago/darBaja",
        data: formData,
      });
  
      if (response.status == 200 || response.status == 201) {
        return ""
      }
    };
  
    const restar = (value, restar) => {
      let result = value - restar;
      //reset
      resto = result > 0 ? 0 : result * -1;
  
      return result < 0
        ? 0
        : "$ " + new Intl.NumberFormat("de-DE").format(result);
    };
  
    useEffect(() => {
      setDetalles(data.detalles);
      setConcesion(data.concesion);
      setConcesionBaja(data.concesion_de_baja);
    }, []);
  
    const infoPago = (e, index) => {
      const info = document.getElementById("info-pago-" + index);
  
      info.classList.add("d-block");
    };
  
    const infoPagoQuit = (e, index) => {
      const info = document.getElementById("info-pago-" + index);
  
      info.classList.remove("d-block");
    };
  
    const onClick = async (e, value) => {
      switch (e.target.name) {
        case "eliminar-pago":
          {
          }
          break;
      }
    };

    return (
        <div class="body p-4">
          {concesion_baja
            ? concesion_baja.map((concesion) => (
              <div
                className="w-100 mb-3"
                style={{
                  borderRadius: "20px",
                  background: "rgba(217, 217, 217, 0.5)",
                }}
              >
                <ul class="list-group bg-transparent">
                  <li class="list-group-item bg-transparent border-0 fw-bold">
                    {tipoConcesion(concesion.id_tipoconcesion)}
                  </li>
                  <li class="list-group-item py-1 bg-transparent border-0 p-3 d-flex justify-content-start">
                    <div className="fs-6 me-2">Fecha de pacto</div>
                    <div className="fs-6 fw-bold">
                      {format(
                        new Date(concesion.fecha_alta),
                        "dd/MM/yyyy"
                      ).toString()}
                    </div>
                  </li>
                  <li class="list-group-item py-1 bg-transparent border-0 p-3 d-flex justify-content-start">
                    <div className="fs-6 me-2">Fecha vencimiento</div>
                    <div className="fs-6 fw-bold">
                      {concesion.inicio_vencimiento == "0000-00-00"
                        ? "Sin plazo"
                        : format(
                          new Date(
                            concesion.inicio_vencimiento + " 00:00:00"
                          ),
                          "dd/MM/yyyy"
                        ).toString()}
                    </div>
                  </li>
                  <li class="list-group-item py-1 bg-transparent border-0 p-3 d-flex justify-content-start">
                    <div className="fs-6 me-2">Bonificación</div>
                    <div className="fs-6 fw-bold">
                      {concesion.porcentaje == 0
                        ? "Sin bonificación"
                        : concesion.porcentaje + "%"}
                    </div>
                  </li>
                  <li class="list-group-item py-1 bg-transparent border-0 p-3 d-flex justify-content-start">
                    <div className="fs-6 me-2">Estado</div>
                    {parseInt(concesion.id_estado) == 4 ? (
                      <div className="fs-6 fw-bold alert alert-danger py-1">
                        Baja
                      </div>
                    ) : parseInt(concesion.id_estado) == 2 ? (
                      <div className="fs-6 fw-bold alert alert-danger py-0">
                        Vencido
                      </div>
                    ) : (
                      ""
                    )}
                  </li>
                </ul>
              </div>
            ))
            : ""}
    
          {concesion ? (
            <div
              className="w-100 mb-3"
              style={{
                borderRadius: "20px",
                background: "rgba(217, 217, 217, 0.5)",
              }}
            >
              <ul class="list-group bg-transparent">
                <li class="list-group-item bg-transparent border-0 fw-bold">
                  {tipoConcesion(concesion.id_tipoconcesion)}
                </li>
                <li class="list-group-item py-1 bg-transparent border-0 p-3 d-flex justify-content-start">
                  <div className="fs-6 me-2">Fecha de pacto</div>
                  <div className="fs-6 fw-bold">
                    {format(
                      new Date(concesion.fecha_alta),
                      "dd/MM/yyyy"
                    ).toString()}
                  </div>
                </li>
                <li class="list-group-item py-1 bg-transparent border-0 p-3 d-flex justify-content-start">
                  <div className="fs-6 me-2">Fecha vencimiento</div>
                  <div className="fs-6 fw-bold">
                    {concesion.inicio_vencimiento == "0000-00-00"
                      ? "Sin plazo"
                      : format(
                        new Date(
                          concesion.inicio_vencimiento + " 00:00:00"
                        ),
                        "dd/MM/yyyy"
                      ).toString()}
                  </div>
                </li>
                <li class="list-group-item py-1 bg-transparent border-0 p-3 d-flex justify-content-start">
                  <div className="fs-6 me-2">Bonificación</div>
                  <div className="fs-6 fw-bold">
                    {concesion.porcentaje == 0
                      ? "Sin bonificación"
                      : concesion.porcentaje + "%"}
                  </div>
                </li>
                <li class="list-group-item py-1 bg-transparent border-0 p-3 d-flex justify-content-start">
                  <div className="fs-6 me-2">Estado</div>
                  {parseInt(concesion.id_estado) == 1 ? (
                    <div className="fs-6 fw-bold alert alert-success py-1">
                      Vigente
                    </div>
                  ) : parseInt(concesion.id_estado) == 2 ? (
                    <div className="fs-6 fw-bold alert alert-danger py-0">
                      Vencido
                    </div>
                  ) : (
                    ""
                  )}
                </li>
              </ul>
            </div>
          ) : (
            ""
          )}
    
          {
            detalles ?
              verificar_bug(detalles) ? (
                <div className="row ">
                  <div className="col-md-3 mb-3">
                    <label className="btn btn-info text-dark">
                      Reacomodar Pagos
                      <button
                        className="d-none"
                        name="reacomodar-pagos"
                        onClick={(event) => onClick(event, detalles)}
                      ></button>
                    </label>
                  </div>
                </div>
              ) : (
                ""
              ) : ""}
    
          <div className="unified-table-container">
            <table className="unified-table">
              <thead>
                <tr>
                  <th className="text-center"><div>ID</div></th>
                  <th className="text-center"><div>Nº Cuota</div></th>
                  <th className="text-center"><div>Vencimiento</div></th>
                  {concesion ? (
                    <th className="text-center"><div>Vencimiento Con.</div></th>
                  ) : (
                    ""
                  )}
                  <th className="text-center"><div>Capital</div></th>
                  <th className="text-center"><div>Intereses</div></th>
                  <th className="text-center"><div>Cuota</div></th>
                  <th className="text-center"><div>Días de mora</div></th>
                  <th className="text-center"><div>Int Moratorio</div></th>
                  <th className="text-center"><div>Total a pagar</div></th>
                  <th className="text-center"><div>Deuda acumulada</div></th>
                  <th className="text-center"><div>Estado</div></th>
                  <th className="text-center"><div>Acciones</div></th>
                  <th className="text-center"><div>Info</div></th>
                </tr>
              </thead>
              <tbody>
                {detalles
                  ? detalles.map((cuota, index) => (
                    <>
                      <tr key={index}>
                        <td className="text-center">{cuota.id}</td>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">
                          {format(
                            new Date(cuota.fecha_vencimiento + " 00:00:00"),
                            "dd/MM/yyyy"
                          ).toString()}
                        </td>
                        {concesion ? (
                          concesion.inicio_vencimiento == "0000-00-00" ? (
                            <td className="text-center">
                              <span className="unified-badge unified-badge-secondary">Sin plazo</span>
                            </td>
                          ) : (
                            <td className="text-center">
                              {format(
                                new Date(
                                  cuota.fecha_vencimiento_concesion
                                    ? cuota.fecha_vencimiento_concesion +
                                    " 00:00:00"
                                    : cuota.fecha_vencimiento + " 00:00:00"
                                ),
                                "dd/MM/yyyy"
                              ).toString()}
                            </td>
                          )
                        ) : (
                          ""
                        )}
                        <td className="text-end">
                          <span className="unified-money">
                            ${" "}
                            {new Intl.NumberFormat("es-AR").format(
                              cuota.capital
                            )}
                          </span>
                        </td>
                        <td className="text-end">
                          <span className="unified-money">
                            ${" "}
                            {new Intl.NumberFormat("es-AR").format(
                              cuota.interes
                            )}
                          </span>
                        </td>
                        <td className="text-end">
                          <span className="unified-money">
                            ${" "}
                            {new Intl.NumberFormat("es-AR").format(
                              cuota.total
                            )}
                          </span>
                        </td>
                        <td className="text-center">
                          <span className={CalculoCuota(cuota).diferencia_moratoria > 0 ? "unified-badge unified-badge-warning" : "unified-badge unified-badge-secondary"}>
                            {CalculoCuota(cuota).diferencia_moratoria} días
                          </span>
                        </td>
                        <td className="text-end">
                          <span className={CalculoCuota(cuota).original_interes_punitorio > 0 ? "unified-money-negative" : "unified-money"}>
                            ${" "}
                            {new Intl.NumberFormat("es-AR").format(
                              CalculoCuota(
                                cuota
                              ).original_interes_punitorio.toFixed(2)
                            )}
                          </span>
                        </td>
                        <td className="text-end">
                          <span className="unified-money">
                            {"$ " +
                              new Intl.NumberFormat("es-AR").format(
                                CalculoCuota(cuota).deuda.toFixed(2)
                              )}
                          </span>
                        </td>
                        <td className="text-end">
                          <span className="d-none">
                            {
                              (deuda =
                                CalculoCuota(
                                  cuota,
                                  JSON.parse(excedente_pago)
                                ).deuda + deuda)
                            }
                          </span>
                          <span className="unified-money">
                            {"$ " +
                              new Intl.NumberFormat("es-AR").format(
                                deuda.toFixed(2)
                              )}
                          </span>
                        </td>
                        <td className="text-center">
                          {parseFloat(deuda).toFixed(0) <= 0 ? (
                            <span className="unified-badge unified-badge-success">Pagado</span>
                          ) : CalculoCuota(
                            cuota
                          ).original_interes_punitorio.toFixed(2) > 0 ? (
                            <span className="unified-badge unified-badge-danger">Vencido</span>
                          ) : (
                            <span className="unified-badge unified-badge-warning">
                              Pendiente
                            </span>
                          )}
                        </td>
                        <td className="text-center">
                          <div className="accordion accordion-flush">
                            <div className="accordion-item border-0">
                              <h2
                                className="accordion-header"
                                id={"flush-headingOne" + index}
                              >
                                <label className="btn btn-sm"
                                  style={{
                                    background: 'linear-gradient(135deg, #155E75 0%, #0F3D4A 100%)',
                                    color: '#FFFFFF',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '6px 12px',
                                    fontSize: '0.85rem',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease'
                                  }}
                                  onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                  onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                  <i className="bi bi-list-ul me-1"></i>Ver Pagos
                                  <button
                                    className="d-none"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={
                                      "#flush-collapseOne" + index
                                    }
                                    aria-expanded="false"
                                  ></button>
                                </label>
                              </h2>
                            </div>
                          </div>
                        </td>
                        <td className="text-center">
                          <label
                            className="btn btn-sm"
                            style={{
                              background: 'linear-gradient(135deg, #0F766E 0%, #0D5E57 100%)',
                              color: '#FFFFFF',
                              border: 'none',
                              borderRadius: '50%',
                              width: '32px',
                              height: '32px',
                              padding: '0',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer'
                            }}
                            title="Impacto de pago"
                          >
                            <i className="bi bi-question-lg"></i>
                            <button
                              className="d-none"
                              name="info-pago"
                              onClick={(event) => infoPago(event, index)}
                            ></button>
                          </label>
                          <div
                            id={"info-pago-" + index}
                            className="info-pago"
                            onMouseOut={(event) =>
                              infoPagoQuit(event, index)
                            }
                          >
                            <InfoPago
                              pago={CalculoCuota(
                                cuota,
                                JSON.parse(excedente_pago)
                              )}
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={14} style={{ padding: '16px', background: 'transparent', border: 'none' }}>
                          <div className="accordion accordion-flush">
                            <div className="accordion-item border-0" style={{ background: 'transparent' }}>
                              <div
                                id={"flush-collapseOne" + index}
                                className="accordion-collapse collapse"
                              >
                                <div className="accordion-body" style={{
                                  padding: '0',
                                  background: '#FFFFFF',
                                  borderRadius: '12px',
                                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                                  overflow: 'hidden'
                                }}>
                                  <div style={{
                                    background: 'linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)',
                                    padding: '12px 20px',
                                    borderBottom: '2px solid #E2E8F0'
                                  }}>
                                    <strong style={{ color: '#1E293B', fontSize: '0.95rem' }}>
                                      <i className="bi bi-cash-stack me-2"></i>Detalle de Pagos - Cuota {index + 1}
                                    </strong>
                                  </div>
                                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead style={{ background: '#F8FAFC' }}>
                                      <tr>
                                        <th style={{ padding: '12px', textAlign: 'left', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>ID</th>
                                        <th style={{ padding: '12px', textAlign: 'left', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Fecha</th>
                                        <th style={{ padding: '12px', textAlign: 'left', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Tipo</th>
                                        <th style={{ padding: '12px', textAlign: 'left', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Forma de pago</th>
                                        <th style={{ padding: '12px', textAlign: 'right', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Importe</th>
                                        <th style={{ padding: '12px', textAlign: 'right', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Int Punit.</th>
                                        <th style={{ padding: '12px', textAlign: 'right', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Interes</th>
                                        <th style={{ padding: '12px', textAlign: 'right', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Capital</th>
                                        <th style={{ padding: '12px', textAlign: 'center', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Acciones</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {InsertCuotas(
                                        cuota.pagos,
                                        JSON.parse(excedente_pago)
                                      ).map((pago, indexPago) => (
                                        <tr key={indexPago} style={{ borderBottom: '1px solid #F1F5F9' }}>
                                          <td style={{ padding: '10px 12px', fontSize: '0.85rem', color: '#1E293B' }}>
                                            {pago.id}
                                          </td>
                                          <td style={{ padding: '10px 12px', fontSize: '0.85rem', color: '#1E293B' }}>
                                            {format(
                                              new Date(
                                                pago.fecha_importe +
                                                " 00:00:00"
                                              ),
                                              "dd/MM/yyyy"
                                            ).toString()}
                                          </td>
                                          <td style={{ padding: '10px 12px', fontSize: '0.85rem', color: '#1E293B' }}>
                                            {pago.estado}
                                          </td>
                                          <td style={{ padding: '10px 12px', fontSize: '0.85rem', color: '#1E293B' }}>
                                            {pago.forma_pago}
                                          </td>
                                          <td style={{ padding: '10px 12px', fontSize: '0.85rem', color: '#059669', fontWeight: '600', textAlign: 'right' }}>
                                            {"$ " +
                                              new Intl.NumberFormat(
                                                "es-AR"
                                              ).format(pago.importe)}
                                          </td>
                                          <td style={{ padding: '10px 12px', fontSize: '0.85rem', textAlign: 'right' }}>-</td>
                                          <td style={{ padding: '10px 12px', fontSize: '0.85rem', textAlign: 'right' }}>-</td>
                                          <td style={{ padding: '10px 12px', fontSize: '0.85rem', textAlign: 'right' }}>-</td>
                                          <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                                            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                              {usuario.rol == "Admin" ? (
                                                <label className="btn btn-sm"
                                                  style={{
                                                    background: 'linear-gradient(135deg, #0F766E 0%, #0D5E57 100%)',
                                                    color: '#FFFFFF',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    padding: '6px 12px',
                                                    fontSize: '0.75rem',
                                                    fontWeight: '600',
                                                    cursor: 'pointer'
                                                  }}
                                                >
                                                  <i className="bi bi-printer me-1"></i>Imprimir
                                                  <button
                                                    className="d-none"
                                                    name="print_"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#comprobante-pago"
                                                    onClick={(event) =>
                                                      onClick(event, {
                                                        pago: pago,
                                                        cuota: cuota,
                                                      })
                                                    }
                                                    title="Se necesita clave de administrador para esa acción"
                                                  ></button>
                                                </label>
                                              ) : (
                                                ""
                                              )}
                                              {pago.id ==
                                                parseInt(
                                                  data.id_ultimo_pago
                                                ) ? (
                                                <label className="btn btn-sm"
                                                  style={{
                                                    background: 'linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)',
                                                    color: '#FFFFFF',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    padding: '6px 12px',
                                                    fontSize: '0.75rem',
                                                    fontWeight: '600',
                                                    cursor: 'pointer'
                                                  }}
                                                >
                                                  <i className="bi bi-lock me-1"></i>Cancelar
                                                  <button
                                                    className="d-none"
                                                    name="eliminar-pago"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#trash-pay"
                                                    onClick={(event) => onClick(event, pago)}
                                                    title="Se necesita clave de administrador para esa acción"
                                                  ></button>
                                                </label>
                                              ) : (
                                                <span style={{ fontSize: '0.85rem', color: '#64748B' }}>-</span>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                      ))}
                                      <tr style={{ background: 'linear-gradient(135deg, #F8FAFC 0%, #E2E8F0 100%)', fontWeight: '700' }}>
                                        <td colSpan={4} style={{ padding: '12px', borderTop: '2px solid #E2E8F0', color: '#1E293B', fontWeight: '700' }}>
                                          TOTAL
                                        </td>
                                        <td style={{ padding: '12px', borderTop: '2px solid #E2E8F0', color: '#059669', fontWeight: '700', textAlign: 'right' }}>
                                          -
                                        </td>
                                        <td style={{ padding: '12px', borderTop: '2px solid #E2E8F0', color: '#dc2626', fontWeight: '700', textAlign: 'right' }}>
                                          {"$ " +
                                            new Intl.NumberFormat(
                                              "es-AR"
                                            ).format(
                                              CalculoCuota(
                                                cuota,
                                                JSON.parse(excedente_pago)
                                              ).interes_punitorio
                                            )}
                                        </td>
                                        <td style={{ padding: '12px', borderTop: '2px solid #E2E8F0', color: '#059669', fontWeight: '700', textAlign: 'right' }}>
                                          {"$ " +
                                            new Intl.NumberFormat(
                                              "es-AR"
                                            ).format(
                                              CalculoCuota(
                                                cuota,
                                                JSON.parse(excedente_pago)
                                              ).interes
                                            )}
                                        </td>
                                        <td colSpan={2} style={{ padding: '12px', borderTop: '2px solid #E2E8F0', color: '#059669', fontWeight: '700', textAlign: 'right' }}>
                                          {"$ " +
                                            new Intl.NumberFormat(
                                              "es-AR"
                                            ).format(
                                              CalculoCuota(
                                                cuota,
                                                JSON.parse(excedente_pago)
                                              ).capital
                                            )}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </>
                  ))
                  : ""}
              </tbody>
              <tfoot></tfoot>
            </table>
          </div>
    
        </div>
      );
}

export default DetalleResumen